import {Button, Modal, Spinner} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { getSiteAnalytics } from "../../services/manage";
import { ErrorBox } from "../ErrorBox/ErrorBox";

import styles from './AnalyticsModal.module.css';
import './Analytics.css';

const MOCK_ANALYTICS = {
  pageviews: 1,
  visitors: 2,
  visits: 1,
  "visit_duration": 1
}

const SingleMetricBox = ({ className, label, value = 12 }) =>
  <div className={`col-10 col-md-5 text-center analytics-${className}`}>
  <div className="value font-26 bold color-purple ms-3 me-3" dangerouslySetInnerHTML={{ __html: value}} />
  <h2 className="font-small bold grey mt-2 ms-3 me-3 mb-3">{label}</h2>
</div>

const ListMetricBox = ({ className, label, values = [] }) =>
  <div className={`analytics-${className} col-12`}>
    <h2 className="font-16 grey mt-3">{label}</h2>
    {values.length > 0 && <div className={styles.list}>
      <table className="w-100">
        {values.map(({label, value}, i) =>
          <tr key={i} className={`position-relative ${i % 2 === 0 ? styles.odd : 'even'}`}>
            <td className={`${styles.label} label`}>{label}</td>
            <td className="text-end value">{value}</td>
        </tr>)}
      </table>
    </div>}
    {values.length === 0 && <div className="font-small light-grey text-center">Unavailable</div>}
  </div>;

const getAvgSessionDuration = (totalDuration = 0, sessionCount = 0) => {
  const value = totalDuration === 0 ? 0 : (totalDuration / sessionCount).toFixed(2);
  return value < 60 ? `${value} <span class="font-16">seconds</span>` : `${(value / 60).toFixed(2)} <span class="font-16">minutes</span>`;
}

const AnalyticsModal = ({ onHide, show, domain, trialMode, onUpgradeCTA }) => {
  const [hasErrored, setHasErrored] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [siteAnalytics, setSiteAnalytics] = useState({});
  //const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

  const fetchAnalyticsInfo = () => {
    getSiteAnalytics({domain: domain.subdomain})
      .then(({ data }) => {
        setSiteAnalytics(data);
        setIsLoading(false)
      }).catch(() => {
        setIsLoading(false);
        setHasErrored(true);
      })
  }

  useEffect(() => {
    if (show) {
      setIsLoading(true)
      if (trialMode) { // provided for trial users
        setSiteAnalytics(MOCK_ANALYTICS);
        setIsLoading(false)
      } else {
        fetchAnalyticsInfo();
      }
    }
  }, [show])

  const onClose = () => {
    setHasErrored(false);
    setSiteAnalytics({})
    onHide()
  }

  return <Modal
    show={show}
    onHide={onClose}
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <div className={`p-4${trialMode ? ' blur-mode' : ''}`}>
      {isLoading && <Spinner className="ms-2" animation="border" variant="primary" />}
      {Object.keys(siteAnalytics).length > 0 && <>
        <h1 className="mb-4 bold color-purple-2 font-22">Link Analytics</h1>
        <div className={styles.row}>
          <SingleMetricBox className="pageviews" label="PAGEVIEWS" value={siteAnalytics.pageviews} />
          <SingleMetricBox className="visitors" label="VISITORS" value={siteAnalytics.visitors} />
          <SingleMetricBox className="sessions" label="SESSIONS" value={siteAnalytics.visits} />
          {!!siteAnalytics.visit_duration && <SingleMetricBox
            className="duration"
            label="AVG. VISIT DURATION"
            value={getAvgSessionDuration(siteAnalytics.visit_duration, siteAnalytics.visits)}
          />}
        </div>
        <div className={styles.row}>
          <ListMetricBox className="source" label="Source" values={siteAnalytics.sources} />
        </div>
        <div className={styles.row}>
          <ListMetricBox className="country" label="Country" values={siteAnalytics.countries} />
        </div>
        {trialMode && <div className={`${styles.trialCTA} mt-4`}>
          <div className="bold">Access all of your metrics</div>
          <Button
            variant="purple"
            onClick={onUpgradeCTA}
          >
            Upgrade to unlock →
          </Button>
        </div>}
      </>}
      {hasErrored && <ErrorBox onClick={onClose} />}
    </div>
  </Modal>
}

export default AnalyticsModal;